import { injectionCountPlugin } from './injectionCount/injectionCount.plugin';
import { withingsPrefillPlugin } from './withingsPrefill/withingsPrefill.plugin';
import type { CheckInCustomPage, CheckInSurveyPlugin } from './types';

export const checkInPlugins: CheckInSurveyPlugin[] = [
  injectionCountPlugin,
  withingsPrefillPlugin,
];

export const checkInCustomPages: Record<string, CheckInCustomPage> =
  checkInPlugins.reduce<Record<string, CheckInCustomPage>>(
    (acc, plugin) => ({ ...acc, ...plugin.pages }),
    {},
  );
